import * as React from 'react';
import {Calendar, momentLocalizer, CalendarProps} from 'react-big-calendar';
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop"
import moment from 'moment';
import 'moment-timezone'
import { Overlay, Tooltip, Button, Row, Col } from "react-bootstrap";
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import '../React-calendar/calendar-component.css';
import { start } from 'repl';

export interface IMyComponentProps {
    events : any;
    scheduledEventTriggered : (event: any) => void,
    slotEventTrigger : (event : any) => void,
    navigateTrigger : (event : any) => void,
    styleSetter : (event : any) => {},
    onView:(event:any)=> void,
}
const DragAndDropCalendar = withDragAndDrop(Calendar as any);
const ReactCalendar : React.FC<IMyComponentProps> = (props:IMyComponentProps) => {   
    const [calendarEvent, setCalendarEvent] = React.useState([])
    function changeTimeZone(date: any, timeZone: any) {
        const event = new Date(date);
        let formattedData = event.toLocaleString('en-US',{timeZone : timeZone})
        return new Date(formattedData)
    }
    React.useEffect(() =>{
   
        let calendarData = props.events.map((events : any, index : any) => {
           
            let startDate = changeTimeZone(events.startTime, localStorage.getItem('timeszone'));
            let endDate = changeTimeZone(events.endTime, localStorage.getItem('timeszone'));
            return {
                id : events.id,
                title : events.title,
                start : startDate,
                end : endDate,
                facilitatorName: events.facilitatorName,
                status : events.meetingStatus,
                startTime:events.startTime,
                endTime:events.endTime,
                source : events.source,
                color : events.color,
                url : events.url,
                resourceId : index,
                meetingTitle: events.meetingTitle,
                calendarType: events.calendarType,
                dueDate: events.dueDate,
                agendaId : events.agendaId,
                recurVisibleFlag:events.recurVisibleFlag,
                isDummyLink:events.isDummyLink,
                isConfidential : events.isConfidential
            }
        })
        setCalendarEvent(calendarData)
    },[props.events])

    function onSelectEvent (event : any){
   
        props.scheduledEventTriggered(event)
    }
    function onSelectSlot (slotInfo : any){
   
        props.slotEventTrigger(slotInfo)
    }
    function onView(view:any){
        props.onView(view)
    }
    function onNavigate (navigateInfo : any){
   
        props.navigateTrigger(navigateInfo)
    }
    const addInlineStyles = (htmlString: any) => {
        // Create a DOM parser
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        
        // Add styles to the table
        const table = doc.querySelector('table');
        if (table) {
          table.style.borderCollapse = 'collapse';
          table.style.width = '100%';
        }
      
        // Add styles to all table headers and cells
        const ths = doc.querySelectorAll('th');
        ths.forEach(th => {
          th.style.border = '1px solid white';
          th.style.padding = '8px';
        });
      
        const tds = doc.querySelectorAll('td');
        tds.forEach(td => {
          td.style.border = '1px solid white';
          td.style.padding = '8px';
        });
      
        // Serialize the document back to a string
        return doc.body.innerHTML;
    };
    const addInlineStyles2 = (htmlString: any) => {
        // Create a DOM parser
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        
        // Add styles to the table
        const table = doc.querySelector('table');
        if (table) {
          table.style.borderCollapse = 'collapse';
          table.style.width = '100%';
        }
      
        // Add styles to all table headers and cells
        const ths = doc.querySelectorAll('th');
        ths.forEach(th => {
          th.style.border = '1px solid black';
          th.style.padding = '8px';
        });
      
        const tds = doc.querySelectorAll('td');
        tds.forEach(td => {
          td.style.border = '1px solid black';
          td.style.padding = '8px';
        });
      
        // Serialize the document back to a string
        return doc.body.innerHTML;
    };
    const styleSetter = (event:any, start : any, end : any) => {
        props.styleSetter(event)    
        let returnValue = {}
        if(event.status == 'COM'){
            returnValue = {
                style : {
                    background : '#63b934',
                    padding : '0px 10px 0px 0px'
                }
            }
        }
        if(event.status == 'PAST'){
            returnValue = {
                style : {
                    background : '#3c265e',
                    padding : '0px 10px 0px 0px'
                }
            }    
        }
        if(event.status == 'CAN'){
            returnValue = {
                style : {
                    background : 'red',
                    padding : '0px 10px 0px 0px'
                }
            }    
        }
        if(event.status == 'SCH'){
            returnValue = {
                style : {
                    background : event.color,
                    padding : '0px 10px 0px 0px'
                }
            }
        }
        if(event.status == 'BSCH'){
            returnValue = {
                style : {
                    background : event.color,
                    padding : '0px 10px 0px 0px'
                }
            }
        }
        if(event.status == null){
            returnValue = {
                style : {
                    background : event.color,
                    padding : '0px 10px 0px 0px'
                }
            }
        }
        if(event.status == ''){
            returnValue = {
                style : {
                    background : event.color,
                    padding : '0px 10px 0px 0px'
                }
            }
        }
        return returnValue
        // return{
            // style : {
            //     background : `${event.status == 'COM' ? '#63b934' : event.status == 'PAST' ? '#3c265e' : event.status == 'CAN' ? 'red' : event.status == null ? event.color : 'none'}`,
            //     padding : '0px 10px 0px 0px'
            // }
        // }
        // return{
        //     style : {
        //         background : `${event.status == 'COM' ? '#63b934' : event.status == 'PAST' ? '#3c265e' : event.status == 'CAN' ? 'red' :}`,
        //         padding : '0px 10px 0px 0px'
        //     }
        // }
    }
    const tooltipRemover = () => {
        return ''
    }
    const TooltipContent = (props : any) => {
        let startTimeData = new Date(props.event.event.start).getTime();
        let endTimeData = new Date(props.event.event.end).getTime();
        let totalDuration = endTimeData - startTimeData
        millisToMinutesAndSeconds(totalDuration);
        function millisToMinutesAndSeconds(millis : any) {
            var minutes = Math.floor(millis / 60000);
            let seconds = ((millis % 60000) / 1000).toFixed(0);
            return (Number(minutes) < 10 ? '0' : '') + minutes + ":" + (Number(seconds) < 10 ? '0' : '') + seconds;
        }
        return (
          <React.Fragment>
              <div className='text-start'>
                <p className='tooltip-table-title'>{props.event.event.source != 'TASK' ? 'Meeting Information' : 'Task Information'}</p>
              </div>
              <table className='text-start'>
                {props.event.event.source == 'ZOOM' &&   
                      <td style={{fontSize : "30px"}}> <img src="assets/zoom1.png" style={{width : "30px"}} alt="" /> {props.event.event.status}</td>
                  }
                  {props.event.event.source == 'AGORAZOOM' &&   
                      <td style={{fontSize : "30px"}}> <img src="assets/Agora-ico.png" style={{width : "30px", marginBottom: '10px'}} alt="" /> {props.event.event.status}</td>
                  }
                  {props.event.event.source != 'TASK' && <tr className='table-row'>  
                      <td>Title:</td><td className='td-data p-l-5px' style={{width : "315px"}}>{props.event.title}</td>
                  </tr>}
                  {props.event.event.source == 'TASK' && <tr className='table-row'>  
                      <td>Title:</td><td className='td-data p-l-5px' style={{width : "315px"}}>{props.event.event.meetingTitle}</td>
                  </tr>}
                  {props.event.event.source == 'TASK' && <tr className='table-row'>
                      <td>Task:</td><td className='td-data p-l-5px' dangerouslySetInnerHTML={{ __html: addInlineStyles2(props.event.event.title) }}></td>
                  </tr>}
                  {props.event.event.source == 'TASK' && <tr className='table-row'>
                      <td>Due Date:</td><td className='td-data p-l-5px'>{(new Date(props.event.event.dueDate).toLocaleDateString('en-US',{weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'})).toString()}</td>
                  </tr>}
                  {props.event.event.source != 'TASK' && <tr className='table-row'>
                      <td>Date:</td><td className='td-data p-l-5px'>{(new Date(props.event.event.start).toLocaleDateString('en-US',{weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'})).toString()}</td>
                  </tr>}
                  {props.event.event.source != 'TASK' &&<tr className='table-row'>
                      <td>Time:</td><td className='td-data p-l-5px'>{(new Date(props.event.event.start).getHours() < 10 ? '0'+new Date(props.event.event.start).getHours() : new Date(props.event.event.start).getHours()) +":"+ (new Date(props.event.event.start).getMinutes() < 10 ? '0'+new Date(props.event.event.start).getMinutes() : new Date(props.event.event.start).getMinutes())} to {(new Date(props.event.event.end).getHours() < 10 ? '0'+new Date(props.event.event.end).getHours() : new Date(props.event.event.end).getHours()) +":"+ (new Date(props.event.event.end).getMinutes() < 10 ? '0'+new Date(props.event.event.end).getMinutes() : new Date(props.event.event.end).getMinutes())}</td>
                  </tr>}
                  {props.event.event.source != 'TASK' && <tr className='table-row'>
                      <td>Duration:</td><td className='td-data p-l-5px'>{millisToMinutesAndSeconds(totalDuration)}</td>
                  </tr>}
                  {props.event.event.source != 'TASK' && <tr className='table-row'>
                      <td>Facilitator:</td><td className='td-data p-l-5px'>{props.event.event.facilitatorName}</td>
                  </tr>}
                  {props.event.event.source != 'TASK' && <tr className='table-row'>
                      <td>Meeting status:</td><td className='td-data p-l-5px'>{props.event.event.status == 'COM' ? 'Completed' : props.event.event.status == 'PAST' ? 'Not Held' : props.event.event.status == 'CAN' ? 'Cancelled' : props.event.event.status == 'SCH' ? 'Scheduled' : props.event.event.status == 'BSCH' ? 'Before scheduled' : ''}</td>
                  </tr>}
                  {/* <tr className='table-row'>
                      <td>Status:</td><td className={props.event.event.status == 'COM' ? 'td-data com-font-green p-l-5px' : props.event.event.status == 'CAN' ? 'td-data can-font-red p-l-5px' : props.event.event.status == 'PAST' ? 'td-data past-font-purple p-l-5px' : 'td-data p-l-5px'}>{props.event.event.status == 'COM' ? 'Completed' : props.event.event.status == 'PAST' ? 'Past' : props.event.event.status == 'CAN' ? 'Cancelled' : ''}</td>
                  </tr> */}
              </table>
          </React.Fragment>
        );
      }
    
    // moment.tz.setDefault(localStorage.getItem('timeszone')!);
    const localizer = momentLocalizer(moment)
    return(
        <div style = {{height: 'calc(100vh - 140px)', margin: '10px'}}>
                <DragAndDropCalendar
                localizer={localizer}
                events={calendarEvent}
                startAccessor="start"
                endAccessor="end"
                step={30}
                timeslots={1}
                onSelectEvent={onSelectEvent}
                onSelectSlot={onSelectSlot}
                onNavigate={onNavigate}
                onView={onView}
                eventPropGetter = {styleSetter}
                // tooltipAccessor = {tooltipRemover}
                selectable
                dayLayoutAlgorithm="no-overlap"
                components = {{event : (event : any) => {
                    let sourceOne = "GOOGLE";
                    let sourceTwo = "OUTLOOK";
                    let sourceThree = "ZOOM";
                    let teamsColor = "#505ac9"
                    let zoomColor = "#2f8afa"
                    const [showTooltip, setShowTooltip] = React.useState(false);

                    const closeTooltip = () => {
                    setShowTooltip(false);
                    };

                    const openTooltip = (e : any) => {
               
                    setShowTooltip(true);
                    }

                    const ref = React.useRef(null);
                    return (
                        <>
                            <div ref={ref} onMouseOver={openTooltip} onMouseLeave = {closeTooltip} title=''>
                            {event.event.source != null && event.event.source != 'MEETING' && event.event.source != 'TASK' && <span className='p-l-5px'>
                                <img src={event.event.source == 'GOOGLE' ? "assets/google.png" : event.event.source == 'OUTLOOK' ? 'assets/outlook.png' : event.event.source == 'ZOOM' ? 'assets/zoom1.png': event.event.source == 'AGORAZOOM' ? 'assets/White-Agora-Logo.png': ''} width="15px" height='15px' style={{marginBottom: '4px'}} />
                            </span>}
                            {/* {event.event.source != null && (event.event.id == '46891' || event.event.id == '46586') && <span className='p-5px cal-icn-bg-white mar-r-5px'>
                                <img src={sourceOne == 'GOOGLE' && event.event.id == '46891' ? "assets/google.png" : sourceTwo == 'OUTLOOK' && event.event.id == '46586' ? 'assets/outlook.png' : ''} width="20px"/>
                            </span>} */}
                            <span className='p-l-10px' id='taskTable' dangerouslySetInnerHTML={{ __html: addInlineStyles(event.title) }}></span>
                            <Overlay
                                rootClose
                                target={ref.current}
                                show={showTooltip}
                                placement='auto'
                                onHide={closeTooltip}
                            >
                                <Tooltip id="test" className='tooltip-content'>
                                    <TooltipContent event={event} onClose={closeTooltip} />
                                </Tooltip>
                            </Overlay>
                            </div>
                        </>
                      );    
                }}}
                />
        </div>
    )
}

export default ReactCalendar
